import React from 'react';
import CategoryPage from '../../categories/CategoryPage';

function DictamenDeDisenoDocumentos() {
  return <CategoryPage category="dictamenDeDisenoDocumentos" pageTitle="Documentos" />;
}

export default DictamenDeDisenoDocumentos;
